import { useSwrNoAuth } from "../swr/useSwrNoAuth";


export const useFetchMenuTypeCustomer = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `menu/restaurants/${restaurantId}/menu/type/` : null;
  const { data: menuType, isLoading } = useSwrNoAuth<string>(fetcherKey)
  return { menuType, isLoading };
};